import { BingSlotContainerNames } from './bing/client-side/ad-slots';

const suppressTextAdSpace = () => {
    Object.values(BingSlotContainerNames)
        .map((attributionDivId) => window.document.getElementById(attributionDivId))
        .forEach((attributionEl) => {
            if (attributionEl && attributionEl.style && attributionEl.style.display) {
                attributionEl.style.display = 'none';
            }
        });
};

export default suppressTextAdSpace;
